<template>
    <v-container fluid class="scroll-y fullscreen accent" pa-0>
        <v-card
            flat
            loader-height="10"
            tile
            min-width="100%"
        >
            <v-list two-line tile flat class="py-0 hover-list primary">
                <v-list-item-group>
                    <template v-for="(job, index) in jobs">
                        <v-list-item
                        :key="`job-${index}`"
                        :value="job.id"                 
                        >
                            <template>
                                <v-list-item-content @click.stop="openJob(job.id)">
                                    <v-list-item-title v-html="'Workorder# ' + job.workorder_no + ' - ' + job.customer.first_name + ' ' + job.customer.last_name" class="white--text"></v-list-item-title>
                                    <v-list-item-subtitle class="white--text">{{ job.customer.street_address+ ', ' + job.customer.city + ', ' + job.customer.state + ' ' + job.customer.zip }}</v-list-item-subtitle>
                                    <div>
                                        <v-chip
                                        class="mr-2 mb-1"
                                        :color="getColor(job.status)"
                                        text-color="white"
                                        small
                                        label
                                        >
                                        {{ job.status | capitalize }}
                                        </v-chip>
                                        <v-chip
                                        class="mr-2 mb-1"
                                        :color="getPriorityColor(job.priority)"
                                        text-color="white"
                                        small
                                        label
                                        >
                                        {{ job.priority | capitalize }}
                                        </v-chip>
                                        <v-chip
                                        class="mr-2 mb-1"
                                        :color="job.difference_color"
                                        text-color="white"
                                        small
                                        label
                                        >
                                        {{ job.difference }}
                                        </v-chip>
                                    </div>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-list-item-icon class="ma-0 mb-1 d-block">
                                        <div class="mb-1">
                                            <v-btn small tile class="mr-1" elevation="0" color="light-green" dark :to="{ name:'Workorder Edit', params:{id: job.id, tab: 'images'} }" width="85">
                                                <v-icon dark class="mr-2">mdi-folder-multiple-image</v-icon> <span class="counter">{{ job.images.length }}</span>
                                            </v-btn>
                                            <v-btn small tile class="mr-1" elevation="0" color="light-blue" dark @click.stop="googleLink(job.customer)">
                                                <v-icon dark>mdi-map-marker</v-icon>
                                            </v-btn>
                                        </div>
                                        <div>
                                            <v-btn small tile class="mr-1" elevation="0" color="light-green" dark v-print="{ id: '#print-'+ index , extraCss: 'https://api.mrpoolal.com/css/print.css', popTitle: 'Workorder# ' + job.workorder_no, previewTitle: 'Workorder# ' + job.workorder_no }" width="85">
                                                <v-icon dark class="mr-2">mdi-printer</v-icon>
                                            </v-btn>
                                            <v-btn small tile class="mr-1" color="accent" elevation="0" dark @click.stop="dial(job.customer.phone)">
                                                <v-icon dark>mdi-phone</v-icon>
                                            </v-btn>
                                        </div>
                                    </v-list-item-icon>
                                </v-list-item-action>
                            </template>
                        </v-list-item>
                        <v-divider
                        :key="`dv-${index}`"
                        ></v-divider>
                        <div :id="`print-${index}`" :key="`print-${index}`">
                            <div style="display: none;" class="printarea">
                                <h4>Workorder #: {{ job.workorder_no }}</h4>
                                <h4>Customer: {{ job.customer.first_name + ' ' + job.customer.last_name }}</h4>
                                <h4>Customer Address: {{ job.customer.street_address+ ', ' + job.customer.city + ', ' + job.customer.state + ' ' + job.customer.zip }}</h4>
                                <h4>Customer Phone: {{ job.customer.phone }}</h4>
                                <h4>Customer Email: {{ job.customer.email }}</h4>
                                <h4>Status: {{ job.status | capitalize }}</h4>
                                <h4>Priority: {{ job.priority | capitalize }}</h4>
                                <h4>Start Date: {{ job.start_date }}</h4>
                                <h4>Follow up Date: {{ job.follow_up_date }}</h4>
                                <h4>Date Serviced: {{ job.date_serviced }}</h4>
                                <h4>Time Serviced: {{ job.time_serviced }}</h4>
                                <h4>Mr. Pool Comments: {{ job.description }}</h4>
                                <h4>Customer Comments: {{ job.customer_description }}</h4>
                                <div v-if="job.chemical_test">
                                    <h4>Clorine Range: {{ job.chemical_test.clorine_range }}</h4>
                                    <h4>PH Range: {{ job.chemical_test.ph_range }}</h4>
                                    <h4>Alkality: {{ job.chemical_test.alkality }}</h4>
                                    <h4>Cyanuric Range: {{ job.chemical_test.cyanuric_range }}</h4>
                                    <h4>Calcium Range: {{ job.chemical_test.calcium_range }}</h4>
                                    <h4>TDS Range: {{ job.chemical_test.tds_range }}</h4>
                                </div>
                                <h4>Estimated Cost: {{ job.estimated_cost }}</h4>
                                <h4>Labor Total: {{ job.labor_total }}</h4>
                                <h4>Material Total: {{ job.material_total }}</h4>
                                <h4>Sales Tax: {{ job.sales_tax }}</h4>
                                <h4>Total Due: {{ job.total_due }}</h4>
                            </div>                          
                        </div>
                    </template>
                </v-list-item-group>  
                <v-list-item v-if="pagination.total > 1" class="accent">
                    <v-list-item-content>
                        <v-pagination
                            v-model="pagination.current"
                            :length="pagination.total"
                            @input="onPageChange"
                            :total-visible="totalVisible"
                            dark
                        ></v-pagination>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios'
import print from 'vue-print-nb'

export default {
    data() {
        return {
            today: new Date().toISOString().substr(0, 10),
            focus: new Date().toISOString().substr(0, 10),
            type: 'month',
            typeToLabel: {
                month: 'Month',
                week: 'Week',
                day: 'Day',
                '4day': '4 Days',
            },
            name: null,
            details: null,
            start: null,
            end: null,
            color: '#1976D2', // default event color
            currentlyEditing: null,
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,
            events: [],
            dialog: false,
            dialogDate: false,
            showmap: true,
            drawer: false,
            drawerCounty: false,
            drawerEmployee: false,
            loading: true,
            downloadLoading: false,
            jobs: [],
            pagination: {
                current: 1,
                total: 0
            },
            totalVisible: 5,
            pageTitle: '',
            apiUrl: '',
            routeKey: '',
            filter: {
                job_no: "",
                keyword: "",
                status: ["active"],
                user: "all",
                priority: ["low", "medium", "high", "urgent"],
                daterange: "",
                county: "",
                order: false
            },
            total: 0,
            markers: [],
            mapKey: 0,
            json_fields: {
                'Date': 'date',
                'Customer Name': 'customer_name',
                'Address': 'address',
                'Chemicals': 'chemicals',
            },
            printObj: {
                asyncUrl (reslove) {
                    setTimeout(() => {
                        reslove('https://api.mrpoolal.com/api/wo/print')
                    }, 2000)
                },
                preview: true,
                previewTitle: 'Print',
                popTitle: 'Print',
                previewPrintBtnLabel: 'Print',
                beforeOpenCallback(){
                    console.log('test')
                },
                openCallback(){
                    console.log('test1')
                },
                closeCallback(){
                    console.log('test2')
                }
            }
        }
    },
    directives: {
        print   
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.apiUrl = this.$route.meta.api
        this.routeKey = this.$route.meta.key
        this.getJobs()
    },
    computed: {
        pageTitleFull() {
            if(this.loading == true) {
                return 'Loading...'
            } else if(this.filter.status != 'all' && this.filter.cleaner != []) {
                //return this.filter.status.charAt(0).toUpperCase() + this.filter.status.slice(1) + ' Jobs'
                return this.pageTitle
            } else {
                return this.pageTitle
            }
        },
        ctitle () {
            const { start, end } = this
            if (!start || !end) {
                return ''
            }
            const startMonth = this.monthFormatter(start)
            const endMonth = this.monthFormatter(end)
            const suffixMonth = startMonth === endMonth ? '' : endMonth
            const startYear = start.year
            const endYear = end.year
            const suffixYear = startYear === endYear ? '' : endYear
            const startDay = start.day + this.nth(start.day)
            const endDay = end.day + this.nth(end.day)
            switch (this.type) {
                case 'month':
                return `${startMonth} ${startYear}`
                case 'week':
                case '4day':
                return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`
                case 'day':
                return `${startMonth} ${startDay} ${startYear}`
            }
            return ''
        },
        monthFormatter () {
            return this.$refs.calendar.getFormatter({
                timeZone: 'UTC', month: 'long',
            })
        },
    },
    methods: {
        getJobs() {
            this.loading = true
            //this.drawer = false
            axios.get('crm/wo/all?page=' + this.pagination.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.jobs = response.data.jobsdata
                this.pagination.current = response.data.jobs.current_page
                this.pagination.total = response.data.jobs.last_page
                this.total = response.data.jobs.total
                this.all = response.data.all
                this.$nextTick()
            })
        },
        onPageChange() {
            this.getJobs()
            this.$vuetify.goTo(0)
        },
        openJob(id) {
            this.$router.push({ path: '/wo/'+id })
        },
        dial (number) {
            window.location ='tel:'+number;
        },
        sendmail (address ){
            window.location = 'mailto:'+address;
        },
        googleLink (customer) {
            let link = 'https://www.google.com/maps?saddr=Current+Location&daddr=' + encodeURI(customer.street_address+ ', ' + customer.city + ', ' + customer.state + ' ' + customer.zip)
            window.open(link, "_blank") || window.location.replace(link)
        },
        updateDrawer(val) {
            this.drawer = val
        },
        updateJobNo(val) {
            this.filter.job_no = val
        },
        updateKeyword(val) {
            this.filter.keyword = val
        },
        updateStatus(val) {
            this.filter.status = val
            this.getJobs()
        },
        updateUser(val) {
            this.filter.user = val
            this.getJobs()
        },
        updateCounty(val) {
            this.filter.county = val
            this.getJobs()
        },
        updatePriority(val) {
            this.filter.priority = val
            this.getJobs()
        },
        updateDaterange(val) {
            this.filter.daterange = val
        },
        orderChange() {
            this.getJobs()
        },
        submitSearch() {
            this.getJobs()
        },
        getColor(status) {
            switch(status) {
                case 'completed':
                    return 'green'
                case 'active':
                    return 'light-blue'
                case 'cancelled':
                    return 'red'
                default:
                    // code block
            }
        },
        getPriorityColor(status) {
            switch(status) {
                case 'low':
                    return 'light-blue'
                case 'medium':
                    return 'green'
                case 'high':
                    return 'orange'
                case 'urgent':
                    return 'red'
                default:
                    // code block
            }
        },
        setDialogDate( { date }) {
            this.dialogDate = true
            this.focus = date
        },
        viewDay ({ date }) {
            this.focus = date
            this.type = 'day'
        },
        getEventColor (event) {
            return event.color
        },
        showEvent ({ nativeEvent, event }) {
            this.$router.push('/job/main/' + event.id)
            nativeEvent.stopPropagation()
        },
        setToday () {
            this.focus = this.today
        },
        prev () {
            this.$refs.calendar.prev()
        },
        next () {
            this.$refs.calendar.next()
        },
        updateRange ({ start, end }) {
            this.start = start
            this.end = end
        },
        nth (d) {
            return d > 3 && d < 21
            ? 'th'
            : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
        },
        drawerToggle() {
            this.drawerCounty = false
            this.drawerEmployee = false
            this.drawer = !this.drawer
        },
        drawerCountyToggle() {
            this.drawerCounty = true
            this.drawerEmployee = false
            this.drawer = !this.drawer
        },
        drawerEmployeeToggle() {
            this.drawerCounty = false
            this.drawerEmployee = true
            this.drawer = !this.drawer
        }
    }
}
</script>
<style lang="sass" scoped>
.theme--light 
    .v-content
        background: #ffffff
.fullscreen
    background: #fff
    height: 100%
.w-100
    width: 100%
    .v-btn 
        width: 100%
.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px
.v-chip 
    border-radius: 0!important
.jobs-count
    font-size: 14px
.jg-header
    background: #1976d2
    color: #fff
    font-size: 18px
</style>